export enum Collections {
    instances = 'instances',
    campaigns = 'campaigns',
    responses = 'responses',
    feedbacks = 'feedbacks',
}

export enum PLANS {
    base = 'base',
    business = 'business',
    enterprise = 'enterprise',
}


export const SUPPORT_EMAIL = 'support@beaver.codes';

const APP_ID = '946691f8-a1a5-49ab-9241-dc4494cc0d0c';
export const UPGRADE_LINK = `https://www.wix.com/apps/upgrade/${APP_ID}?appInstanceId=`

export const DEFAULT_CAMPAIGN_DATA = {
    name: 'My New Campaign',
    labelNps: 'How are we doing?',
    labelComment: 'What can we do to improve?',
    labelThankYou: 'Thank you for your feedback!',
    labelSubmit: 'Submit',
    // logoUrl: '',
    logoUrl: 'https://static.wixstatic.com/media/896d2a_b372282cdc2c4091920504b25f4035ee~mv2.png',
}

export const WIDGET_ASSET_BASE_NAME = 'wix-customer-feedback';
export const WIDGET_SCRIPT_PATH = `/widget/${WIDGET_ASSET_BASE_NAME}.js`

export const FREE_CAMPAING_LIMIT = 1;
export const FREE_RESPONSE_LIMIT = 5;
